export default __webpack_public_path__ + "static/media/ios-store.png";